import React, {useContext, useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import {AppContext} from '../../context/app/appContext';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ProgressBar from './ProgressBar';
import axios from 'axios'

export const HomeAbel = (props) => {

    // const appContext = useContext(AppContext);
    const percentage = 66;
    const [pollsComp, setPollsComp] = useState();
    const [pollsTotal, setPollsTotal] = useState();
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    console.log("access token = ", accessToken)
    const appContext = useContext(AppContext)
    console.log("User Email",appContext.user)
    let data=[]
    // axios.post('http://localhost:8080/poll/fetch/hr', {email: appContext.user.email}).then(res => {
    //     console.log("Save poll data", res.data) 
    //     savePollData(res.data)
    // }).catch(error => console.log(error));

    useEffect(() => {
        console.log("before poll request ")
        axios.post(baseURL+'/poll/fetch/hr', {email: appContext.user.email},{headers : {
            Authorization: "Bearer "+localStorage.getItem('accessToken')}
        }).then(res => {
        console.log("Save poll data", res.data) 
        savePollData(res.data)
    }).catch(error => console.log(error));
    }, [])
    function savePollData(item){
        console.log("check here= ",item)


        var d1 = new Date();
        var year = d1.getFullYear();
        var month = d1.getMonth()+1;
        var day = d1.getDate();
        let temp;
        const temp1 = []
        const temp2 = []
        const temp3 = []
        for (const i of item){

            if(i.startDate==undefined || i.startDate.length==8) continue;
            if(i.endDate==undefined || i.endDate.length==8) continue;
            // console.log("item details = ", i)
            const year1 = parseInt(i.startDate.slice(0,4))
            const month1 = parseInt(i.startDate.slice(5,7))
            const day1 = parseInt(i.startDate.slice(8,10))
            const year2 = parseInt(i.endDate.slice(0,4))
            const month2 = parseInt(i.endDate.slice(5,7))
            const day2 = parseInt(i.endDate.slice(8,10))
            // console.log("dates = ", year)
            

            var level=0
            //1 completed -1 not started 0 in progress
            if(year2<year ||(month2<month && year2==year)||(day2<day && month2==month && year2==year)){level=1}


            if(year1>year){level=-1}
            if(month1>month && year1==year){level=-1}
            if(day1>day && year1==year && month1==month){level=-1}
            console.log("level = ", level)

            if(level==-1){
                temp1.push(i)
            }
            else if(level==1){
                temp2.push(i)
            }
            else{
                temp3.push(i)
            }

        }
        console.log("in progress data = ", temp3)
        console.log("completed data = ", temp2)
        console.log("not started data = ", temp1)
        setPollsComp(temp2.length)
        setPollsTotal(temp1.length+temp2.length+temp3.length)
        // setNotStartedPolls(temp1);
        // setCompletedPolls(temp2);
        // setInProgressPolls(temp3);
        
    }
    return (
        <div style={{width: "100%", height: "100%", display: "flex", flexDirection: "row", marginLeft: 10, marginRight: 10}}>
            <div style={{flex: 0}}>
                <ProgressBar
                    percentage={10}
                    startColor="rgba(0, 200, 136, 1)"
                    endColor="rgba(0, 100, 68, 1)"
                    gradientId="progress"
                    // value = {pollsTotal === 0 ? 94 : parseInt(pollsComp*100/pollsTotal)}
                    value = {94}
                >
                    <div style={{color: 'rgba(133, 133, 133, 1)', fontSize: 14, fontStyle: 'SFProText-Bold',
                            background: "-webkit-linear-gradient(rgba(0, 200, 136, 1), rgba(0, 0, 0, 1))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", }}>
                        {/* {pollsComp} */}
                        94
                    </div>
                </ProgressBar>
            </div>
                <div style={{alignItems: 'center', justifyContent: 'center', flex: 1, display: 'flex', flexDirection: 'column'}}>
                    <div style={{color: 'rgba(133, 133, 133, 1)', fontStyle:'SFProText-Bold', fontSize: 16, marginBottom: 10}}>Polls Completed</div>
                    {/* <div style={{color: 'rgba(28, 209, 161, 1)', fontStyle:'SFProText-Bold', fontSize: 20, marrginTop: 10}}>{pollsTotal === 0 ? 94 : parseInt(pollsComp*100/pollsTotal)}%</div> */}
                    <div style={{color: 'rgba(28, 209, 161, 1)', fontStyle:'SFProText-Bold', fontSize: 20, marrginTop: 10}}>94 %</div>
                </div>
        </div>
    );
};
